import {
  REQUEST_ROBOTS_PENDING,
  REQUEST_ROBOTS_SUCCESS,
  REQUEST_ROBOTS_FAILED,
  IRobotState,
  RobotActionTypes,
  IRequestRobotsSuccessAction,
  IRequestRobotsFailedAction,
} from "./types";

const initialState: IRobotState = {
  items: [],
  isPending: false,
  error: "",
};

const robotReducer = (
  state: IRobotState = initialState,
  action: RobotActionTypes
): IRobotState => {
  switch (action.type) {
    case REQUEST_ROBOTS_PENDING:
      return Object.assign({}, state, { isPending: true });
    case REQUEST_ROBOTS_SUCCESS:
      return Object.assign({}, state, {
        items: (action as IRequestRobotsSuccessAction).payload,
        isPending: false,
        error: "",
      });
    case REQUEST_ROBOTS_FAILED:
      return Object.assign({}, state, {
        isPending: false,
        error: (action as IRequestRobotsFailedAction).payload,
      });
    default:
      return state;
  }
};

export default robotReducer;
